import React from 'react';
import styles from './ui.module.css';

interface SurfaceProps {
  title?: React.ReactNode;
  /** Right-hand side of the card header — a count, a date, a toggle. */
  meta?: React.ReactNode;
  actions?: React.ReactNode;
  footer?: React.ReactNode;
  /** Pad the body. Leave off when the body is a table that should meet the edges. */
  padded?: boolean;
  /** Grow to fill the page frame, so the card's height comes from the page and
   *  not from how much data arrived. */
  fill?: boolean;
  className?: string;
  children: React.ReactNode;
}

/**
 * The standard card. One card is one job: a filter bar, a table, a chart.
 * A page is a stack of these on the canvas, never one card wrapping everything.
 */
const Surface: React.FC<SurfaceProps> = ({
  title,
  meta,
  actions,
  footer,
  padded = false,
  fill = false,
  className = '',
  children,
}) => (
  <section
    className={[styles.surface, fill ? styles.surfaceFill : '', className].filter(Boolean).join(' ')}
  >
    {(title || meta || actions) && (
      <div className={styles.surfaceHead}>
        {title && <h2 className={styles.surfaceTitle}>{title}</h2>}
        <div className={styles.surfaceActions}>
          {meta && <span className={styles.surfaceMeta}>{meta}</span>}
          {actions}
        </div>
      </div>
    )}
    <div className={`${styles.surfaceBody}${padded ? ` ${styles.surfacePad}` : ''}`}>{children}</div>
    {footer && <div className={styles.surfaceFoot}>{footer}</div>}
  </section>
);

export default Surface;
